import {
  MdAssignmentInd,
  MdDashboard,
  MdLibraryBooks
} from "react-icons/md";
import appConfig from "../../../../helpers/config";
import { baseRoutes } from "../../../../routes/base-routes";
import { SvgIcons } from "../../SvgIcons";
const basePath = appConfig.basePath;
export const NavItems = [
  {
    id: 1,
    menuName: "Dashboard",
    menuIcon: <MdDashboard size={21} />,
    path: `${basePath}/dashboard`,
    disabled: false, 
    hideInMobile: false
  },
  {
    id: 4,
    menuName: "Notes",
    menuIcon: <MdLibraryBooks size={22} />,
    path: `${basePath}/notes`,
    disabled: false, 
    hideInMobile: false
  }
];
